export default __webpack_public_path__ + "static/media/expl-dissect_04_DE.45a24e24.png";